import React from 'react';
import classnames from 'classnames';

import WpImage from 'components/WPImage';

import { excerptText, bannerImage } from '../styles.module.scss';

const Default = ({ title, excerpt, banner }) => {
  return (
    <div className="flex flex-col">
      <div className="sm:w-8/12 ">
        <h1 className="oc-h2 mb-4 sm:mb-6 font-medium">{title}</h1>

        <div
          className={classnames(excerptText, 'oc-subtitle mb-6 sm:mb-10')}
          dangerouslySetInnerHTML={{ __html: excerpt }}
        ></div>
      </div>

      {banner?.node?.sourceUrl ? (
        <WpImage
          src={banner?.node.sourceUrl}
          alt={banner?.node.altText}
          className={bannerImage}
        />
      ) : null}
    </div>
  );
};

export default Default;
